import React, { useState, Dispatch, SetStateAction } from "react";
import "./Joystick.scss";
import infoIcon from "../../assets/images/info.png";

interface JoystickProps {
  tiltX: (angle: number) => void;
  tiltY: (angle: number) => void;
  tiltZ: (angle: number) => void;
  translateX: (distance: number) => void;
  translateY: (distance: number) => void;
  translateZ: (distance: number) => void;
  primary_color?: string;
  showControls: (shouldShow: boolean) => void;
  setShowArInfo: Dispatch<SetStateAction<boolean>>;
  showHideControlsButton: Dispatch<SetStateAction<boolean>>;
}

const Joystick: React.FC<JoystickProps> = ({
  tiltX,
  tiltY,
  tiltZ,
  translateX,
  translateY,
  translateZ,
  primary_color,
  setShowArInfo,
  showControls,
  showHideControlsButton,
}) => {
  const [mode, setMode] = useState("Move");
  const [moveX, setMoveX] = useState(0);
  const [moveY, setMoveY] = useState(0);
  const [moveZ, setMoveZ] = useState(0);
  const [tiltXState, setTiltXState] = useState(0);
  const [tiltYState, setTiltYState] = useState(0);
  const [tiltZState, setTiltZState] = useState(0);

  const handleSliderChange = (axis: any, value: string) => {
    const intValue = parseInt(value);
    let diff = 0;

    if (mode === "Move") {
      switch (axis) {
        case "X":
          diff = intValue - moveX;
          setMoveX(intValue);
          translateX(diff * 0.1); // scale for Move mode
          break;
        case "Y":
          diff = intValue - moveY;
          setMoveY(intValue);
          translateY(diff * 0.1); // scale for Move mode
          break;
        case "Z":
          diff = intValue - moveZ;
          setMoveZ(intValue);
          translateZ(diff * 0.1); // scale for Move mode
          break;
        default:
          console.error(`Invalid axis: ${axis}`);
          return;
      }
    } else {
      switch (axis) {
        case "X":
          diff = intValue - tiltXState;
          setTiltXState(intValue);
          tiltX(diff * 3); // scale for Tilt mode
          break;
        case "Y":
          diff = intValue - tiltYState;
          setTiltYState(intValue);
          tiltY(diff * 3); // scale for Tilt mode
          break;
        case "Z":
          diff = intValue - tiltZState;
          setTiltZState(intValue);
          tiltZ(diff * 3); // scale for Tilt mode
          break;
        default:
          console.error(`Invalid axis: ${axis}`);
          return;
      }
    }
  };

  return (
      <div
        style={{
          position: "absolute",
          bottom: "135px",
          left: 0,
          right: 0,
          margin: "auto",
        }}
      >
        <div className="helloar-container">
          <div className="helloar-left">
            <div className="helloar-ar-info">
              <h4 className="helloar-ar-info-title">Adjust your model</h4>
              <div
                onClick={() => {
                  showHideControlsButton(false)
                  setShowArInfo((prev) => !prev);
                  showControls(false);
                }}
                className="helloar-icon-container"
              >
                <div className="helloar-img-container">
                  <img src={infoIcon} />
                </div>
              </div>
            </div>
            <div className="helloar-axis">
              <label>{mode === "Move" ? "Sideways" : "Forwards"}: </label>
              <div className="helloar-range">
                <input
                  className="helloar-joystick-input"
                  type="range"
                  min={mode === "Move" ? "-20" : "-30"}
                  max={mode === "Move" ? "20" : "30"}
                  value={mode === "Move" ? moveX : tiltXState}
                  onChange={(e) => handleSliderChange("X", e.target.value)}
                />
              </div>
            </div>
            {mode === "Move" && (
              <div className="helloar-axis">
                <label>Upwards: </label>
                <div className="helloar-range">
                  <input
                    className="helloar-joystick-input"
                    type="range"
                    min={mode === "Move" ? "-20" : "-30"}
                    max={mode === "Move" ? "20" : "30"}
                    value={mode === "Move" ? moveY : tiltYState}
                    onChange={(e) => handleSliderChange("Y", e.target.value)}
                  />
                </div>
              </div>
            )}
            <div className="helloar-axis">
              <label>{mode === "Move" ? "Forwards" : "Sideways"}: </label>
              <div className="helloar-range">
                <input
                  className="helloar-joystick-input"
                  type="range"
                  min={mode === "Move" ? "-20" : "-30"}
                  max={mode === "Move" ? "20" : "30"}
                  value={mode === "Move" ? moveZ : tiltZState}
                  onChange={(e) => handleSliderChange("Z", e.target.value)}
                />
              </div>
            </div>
            <div
              className="helloar-joystick-tabs"
              style={
                {
                  "--primary-color": primary_color ? primary_color : "#57CA85",
                } as any
              }
            >
              <button
                className={`helloar-joystick-tab ${mode === "Move" ? "active" : ""}`}
                onClick={() => setMode("Move")}
              >
                Move
              </button>
              <button
                className={`helloar-joystick-tab ${mode === "Tilt" ? "active" : ""}`}
                onClick={() => setMode("Tilt")}
              >
                Tilt
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Joystick;
